<template>
  <div
    v-if="!estimatesLoading"
    class="page">
    <app-title
      :page="estimate.project"
      :prehead="estimate.client">
      <div
        slot="action"
        class="align-right order-0 order-1_sm"><button
          class="invisible-button"
          @click.prevent="settings"><svg-settings/> Estimate settings</button></div>
      <div slot="content">
        <div
          v-if="estimate.description"
          class="measure font-size-4"><vue-markdown :source="estimate.description">{{ estimate.description }}</vue-markdown></div>
      </div>
    </app-title>
    <section v-if="estimatesLoading === false && ratesLoading === false">
      <app-estimate-report/>
      <div class="grid grid-gap-2 breakdowns">
        <transition
          mode="out-in"
          name="table-slide"
          @before-enter="beforeEnter"
          @after-enter="afterEnter"
          @before-leave="beforeLeave"
          @after-leave="afterLeave">
          <app-role-breakdown
            v-if="estimate.showRoleBreakdown"
            :page="page"
            :class="[
              estimate.showTeamBreakdown ? 'grid-column-half' : 'grid-column-full roles-full',
              estimate.showTeamBreakdown && estimate.showRoleBreakdown ? 'both-half' : '',
              'breakdown role-breakdown']"/>
        </transition>
        <transition
          mode="out-in"
          name="table-slide"
          @before-enter="beforeEnter"
          @after-enter="afterEnter"
          @before-leave="beforeLeave"
          @after-leave="afterLeave">
          <app-team-breakdown
            v-if="estimate.showTeamBreakdown"
            :page="page"
            :class="[
              estimate.showRoleBreakdown ? 'grid-column-half' : 'grid-column-full team-full',
              estimate.showTeamBreakdown && estimate.showRoleBreakdown ? 'both-half' : '',
              'breakdown team-breakdown']"/>
        </transition>
        <p
          v-if="estimate.showRoleBreakdown || estimate.showTeamBreakdown"
          class="font-size-1 grid-column-full">* Target values are averaged and rounded and may not add up exactly in each column.</p>
      </div>
      <section class="grid grid-columns-1 grid-columns-4_lg grid-gap-hair estimate-tools grid-dense mb-margin">
        <app-estimate-menu :page="page"/>
        <app-estimate-tasks :class="estimate.showRedFlags ? 'grid-column-span-3_lg ' : 'grid-column-span-4_lg'"/>
        <app-red-flags
          v-if="!redFlagLoading && estimate.showRedFlags"
          :page="page"/>
      </section>
    </section>
    <transition
      name="slide-top"
      mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import VueMarkdown from 'vue-markdown'
import page from '../mixins/page'
import EstimateReport from './EstimateReport'
import EstimateMenu from './EstimateMenu'
import EstimateTasks from './EstimateTasks'
import EstimateRedFlags from './EstimateRedFlags'
import RoleBreakdown from './RoleBreakdown'
import TeamBreakdown from './TeamBreakdown'
import Settings from '../svgs/Settings'

export default {
  components: {
    appEstimateReport: EstimateReport,
    appEstimateTasks: EstimateTasks,
    appEstimateMenu: EstimateMenu,
    appRedFlags: EstimateRedFlags,
    appRoleBreakdown: RoleBreakdown,
    appTeamBreakdown: TeamBreakdown,
    svgSettings: Settings,
    vueMarkdown: VueMarkdown
  },
  mixins: [ page ],
  data () {
    return {
      page: this.$route.params.id
    }
  },
  computed: {
    ...mapGetters([
      'ratesLoading',
      'redFlagLoading',
      'estimatesLoading',
      'user'
    ]),
    estimate () {
      return this.$store.getters.estimate(this.page)
    }
  },
  methods: {
    settings () {
      this.$router.push({ name: 'estimateSettings' })
    },
    beforeEnter (el) {
      // Setup clone
      let clone = el.cloneNode(true)
      clone.style.width = el.style.width
      clone.style.visibility = 'hidden'
      clone.style.removeProperty('display')

      // if inner animation (might be undesired)
      const desc = clone.querySelectorAll('*')
      desc.forEach(item => {
        // remove possible inline styles of display(=none)
        item.style.removeProperty('display')
      })

      // get clone height
      el.parentNode.appendChild(clone)
      const h = clone.clientHeight
      clone.remove()

      // Force animation instead of simple "setting a height"
      el.style.height = '0px'
      setTimeout(() => {
        el.style.height = h + 'px'
      }, 1)
    },
    afterEnter (el) {
      el.style.removeProperty('height')
    },
    beforeLeave (el) {
      el.style.height = el.clientHeight + 'px'
      setTimeout(() => { el.style.height = '0px' }, 1)
    },
    afterLeave (el) {
      el.style.removeProperty('height')
    }
  }
}
</script>

<style>
  @media screen and (min-width: 48em) {
    .breakdowns {
      grid-template-columns: minmax(100px, 1fr) minmax(100px, 1fr);
    }
  }
  .table-slide-enter-active {
    transition: all 0.3s cubic-bezier(.3,-0.05,.13,1.25);
  }
  .table-slide-leave {
    opacity: 1;
  }
  .table-slide-leave-to {
    opacity: 0;
  }
  @media screen and (max-width: 48em) {
    .table-slide-leave-active {
      transition: all 0.2s cubic-bezier(0,-0.35,.5,1.25);
    }
  }
  @media screen and (min-width: 48em) {
    .table-slide-leave-active.grid-column-full {
      transition: all 0.2s cubic-bezier(0,-0.35,.5,1.25);
    }
  }
</style>
